export const CONTACTS = {
  phone : '+780055500',
  fax : '00832021',
  email : 'probegrofanston@mail.ru'
};
